import {IMarketingInfo, IClientStatus, IContactInfo, IObjectAudit, IPosition, ESizeOfBusiness, ETypeOfBusiness } from "../../../models"
import { IClientContactDocument } from './ClientContactDocument';

export interface IClientDocument {
    Id: string
    AccountId: string
    Name: string
    Type: string
    CustomerType: string
    Status: IClientStatus
    HierarchyId: string
    ExternalId: string
    ExternalId2: string
    ExternalId3: string
    ContactInfo: IContactInfo
    ReferralSource: string
    ReferredBy: string
    ActiveStatus: EClientActiveStatus
    PrimaryContactId: string
    PrimaryContact: IClientContactDocument
    BillingContactId: string
    BillingContact: IClientContactDocument
    ObjectAudit: IObjectAudit
    LogoS3Url: string
    Deleted: boolean
    TicksSinceChange: number
    Positions: IPosition[]
    Website: string
    QuickNotes: IClientQuickNotes
    Field1: string
    Field2: string
    Field3: string
    Field4: string
    CompanyType: ETypeOfBusiness
    CompanySize: ESizeOfBusiness
    MarketingInfo: IMarketingInfo
    RelationshipManagerUserId: string
    RelationshipManagerUserName: string
}

export interface IClientQuickNotes {
    Notes: string
    Notes2: string
    BillingNotes: string
}

export enum EClientActiveStatus {
    Active,
    Inactive,
    Pending
}